module.exports = __webpack_public_path__ + "img/deposit@2x.fba165c3.png";